<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card>
          <template slot="actions">
            <vs-button @click.stop="onClickCreate()">Create</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table pagination max-items="10" :data="partner_agreement_list" @sort="handleSort" stripe
              class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th>ACCOUNT NUMBER</vs-th>
                <vs-th>CUSTOMER NAME</vs-th>
                <vs-th>DATE INTRODUCED</vs-th>
                <vs-th>CREATED AT</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr"
                  v-for="(tr, indextr) in data">
                  
                  <vs-td>
                    {{ data[indextr].customer.account_number }}
                  </vs-td>
                  <vs-td :data="data[indextr].customer.name">
                    {{ data[indextr].customer.name }}
                  </vs-td>
                  <vs-td>
                    {{ data[indextr].date_introduced }}
                  </vs-td>
                  <vs-td>
                    {{ __dateTimeFormatter(data[indextr].created_at) }}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View Agreements" position="left">
                        <vs-button class="ml-3" @click="onClickViewManufacturing(data[indextr])" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

          </div>
        </vx-card>
      </div>
    </div>
    <CreateChannelPartnerAgreementPopUp ref="createChannelPartnerAgreementPopUp"/>
    <ViewChannelPartnerCustomerAgreementsPopUp ref="viewChannelPartnerCustomerAgreementsPopUp"/>
    <CreateChannelPartnerCustomerAndAgreementPopUp ref="createChannelPartnerCustomerAndAgreementPopUp"/>
  </div>
</template>

<script>

import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const SupplierRepository = RepositoryFactory.get('supplier');
const ChannelPartnerRepository = RepositoryFactory.get('channel_partner')
import CreateChannelPartnerAgreementPopUp from '@/components/popups/tenants/channel-partners/CreateChannelPartnerAgreementPopUp.vue'
import ViewChannelPartnerCustomerAgreementsPopUp from '@/components/popups/channel-partners/ViewChannelPartnerCustomerAgreementsPopUp.vue'
import CreateChannelPartnerCustomerAndAgreementPopUp from '@/components/popups/channel-partners/CreateChannelPartnerCustomerAndAgreementPopUp.vue'

export default {
  name: 'ChannelPartnerCustomerList',
  data() {
    return {
      partner_agreement_list: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      supplierId: ''
    }
  },
  components: {
    CreateChannelPartnerAgreementPopUp,
    ViewChannelPartnerCustomerAgreementsPopUp,
    CreateChannelPartnerCustomerAndAgreementPopUp
  },
  props: {
    partner_id: {
      required: true,
      default: ''
    }
  },
  mixins: [Filter],
  async mounted() {
  },
  methods: {
    async refreshData() {
      this.fetchManufacturingSites()
    },

    async fetchManufacturingSites() {
      this.$vs.loading()
      const { data } = await ChannelPartnerRepository.getChannelPartnerCustomers(this.partner_id, this.page, 20)
      this.partner_agreement_list = data.data
      this.meta = data.meta
      this.$vs.loading.close()
    },
    onClickViewManufacturing(data) {
      this.$refs.viewChannelPartnerCustomerAgreementsPopUp.openPopup(data)
    },
    filterQueryUpdate() {
      this.fetchManufacturingSites()
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchManufacturingSites()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchManufacturingSites()
      }

    },
    onClickCreate() {
      this.$refs.createChannelPartnerCustomerAndAgreementPopUp.openPopup()
    }

  },
}
</script>


<style scoped></style>
